
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment améliorer son site Internet ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "L’audience de votre site Internet stagne depuis plusieurs mois et vous n’attirez plus de nouveaux clients. Cet article vous explique comment faire pour relancer la machine.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment améliorer son site Internet ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "L’audience de votre site Internet stagne depuis plusieurs mois et vous n’attirez plus de nouveaux clients. Cet article vous explique comment faire pour relancer la machine.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
